import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository, getManager } from "typeorm";
import { LocationById } from "./dto/locaion-get-by-id.dto";
import { LocationAdapater } from "./dto/location-adpater";
import { LocationDTO } from "./dto/location-dto";
import { LocationByIdReq } from "./dto/location-id-request";
import { Location } from "./dto/loction-entity";
import { LocationByPlant } from "./dto/location-by-plant.dto";
import appSettings from "apps/services/config";
import { AssetsLocationDto } from 'libs/shared-models/asset-management/src/lib/asset-location/asset-location.dto';

@Injectable()
export class LocationService {
    constructor(
        private locationAdapter: LocationAdapater,
        @InjectRepository(Location)
        private LocationRepository: Repository<Location>,
    ) { }



    async create(createDto: LocationDTO): Promise<CommonResponse> {
        const getEntites: Location[] = await this.LocationRepository.find({ where: { plant: createDto.plant, locationName: createDto.locationName,locationHead:createDto.locationHead } });
        if (getEntites.length > 0) {

            return new CommonResponse(false, 99898, 'Location Already Exist!')
        }
        else {
            const entity = this.locationAdapter.convertDtotoEntity(createDto);
            const saveLocation = await this.LocationRepository.save(createDto)
            return new CommonResponse(true, 1, "Successfully Created", saveLocation)
        }
    }


    async getAllAssets(req?: LocationByPlant): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT lo.location_id,lo.location_name,unc.unit_name AS plant,lo.is_active,lo.version_flag,em.employee_name as locationHead,unc.unit_code_id AS plantId,
        lo.plant as plantId FROM `+ appSettings.assets_db + `.location lo
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = lo.plant
        LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = lo.location_head
        
        WHERE lo.location_id > 0 `;
        if (req.plant > 0 && req.plant != 5) {
            getEntities = getEntities + 'and lo.plant = ' + req.plant
        }
        getEntities = getEntities + ' GROUP BY lo.location_id '
        const data: { location_id: number, location_name: string, plant: number,locationHead:string , is_active: boolean,version_flag: number,plantId:number }[] = await manager.query(getEntities)
        const response = [];
        data.forEach(e => {
            response.push(new AssetsLocationDto(e.location_id, e.location_name, null, e.is_active,null,e.version_flag, e.plant,e.locationHead,e.plantId))
        })
        return new CommonResponse(true, 1, 'Data retrieved', response)
    }


    async getById(req: LocationById): Promise<CommonResponse> {
        const response = await this.LocationRepository.findOne({ where: { locationId: req.locationId } });
        if (response) {
            return new CommonResponse(true, 1, 'Data retrieved successfully', response)
        } else {
            return new CommonResponse(false, 99898, 'Location Id not found')
        }
    }

    async getLocationById(id: number): Promise<Location> {
        const response = await this.LocationRepository.findOne({ where: { locationId: id } });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivate(req: LocationByIdReq): Promise<CommonResponse> {
        try {
            const certExists = await this.getLocationById(req.locationId);
            if (certExists) {
                if (req.versionFlag !== certExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Location informations. Refresh and try again');
                } else {
                    const certStatus = await this.LocationRepository.update(
                        { locationId: req.locationId },
                        { isActive: req.isActive, updatedUser: req.updatedUser }
                    );
                    if (certExists.isActive) {
                        if (certStatus.affected) {
                            // const response: CertificationResponseModel = new CertificationResponseModel(true, 10115, 'Certification de-activated successfully');
                            // return response;
                            return new CommonResponse(true, 1, 'Location de-activated Successfully')
                        } else {
                            throw new ErrorResponse(10111, 'Location is already de-activated');
                        }
                    } else {
                        if (certStatus.affected) {
                            // const response: CertificationResponseModel = new CertificationResponseModel(true, 10114, 'Certification activated successfully');
                            // return response;
                            return new CommonResponse(true, 1, 'Location activated Successfully')
                        } else {
                            throw new ErrorResponse(10112, 'Location is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, "No Records Found");
            }
        } catch (error) {
            throw error;
        }
    }

    async update(req: LocationDTO): Promise<CommonResponse> {
        const getEntites: Location = await this.LocationRepository.findOne({ where: { locationId: req.locationId } });
        if (getEntites) {
            const convertedEntity: Location = this.locationAdapter.convertDtotoEntity(req)
            const savedEntity: Location = await this.LocationRepository.save(convertedEntity);
            const savedDto: LocationDTO = this.locationAdapter.convertEntitytoDto(savedEntity);
            if (savedDto) {
                await this.updateServiceOwnerForLocation(req.locationId);
                const response = new CommonResponse(true, 1, 'Location updated Successfully', savedDto);
                return response;
            }
        } else {
            return new CommonResponse(false, 11106, 'Location not found')
        }

    }

    async updateServiceOwnerForLocation(locationId: number): Promise<void> {
        const manager = getManager();
        const batchSize = 100; // Define the size of each batch
        let offset = 0;
    
        while (true) {
            // Fetch a batch of asset services to update
            const recordsToUpdate = await manager.query(
                `SELECT ass.asset_id
                 FROM shahi_assets.asset_service ass
                 JOIN shahi_assets.asset_location_mapping loc ON loc.asset_id = ass.asset_id
                 JOIN shahi_assets.location lcc ON lcc.location_id = loc.location_id
                 WHERE ass.status = 'OPEN' AND lcc.location_id = ?
                 LIMIT ? OFFSET ?`,
                [locationId, batchSize, offset]
            );
    
            // If no more records to update, break the loop
            if (recordsToUpdate.length === 0) {
                break;
            }
    
            // Update service owner for the current batch
            const assetIds = recordsToUpdate.map(record => record.asset_id);
            await manager.query(
                `UPDATE shahi_assets.asset_service ass
                 JOIN shahi_assets.asset_location_mapping loc ON loc.asset_id = ass.asset_id
                 JOIN shahi_assets.location lcc ON lcc.location_id = loc.location_id
                 JOIN shahi_asset_master.employee_details emp ON emp.employee_id = lcc.location_head
                 SET ass.service_owner = emp.employee_name
                 WHERE ass.status = 'OPEN' AND ass.asset_id IN (?)`,
                [assetIds]
            );
    
            // Move to the next batch
            offset += batchSize;
        }
    }

    async getLocationByPlant(req: LocationByPlant): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities
        getEntities = `SELECT lo.location_id,lo.location_name,unc.unit_name AS plant
         FROM `+ appSettings.assets_db + `.location lo
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = lo.plant WHERE lo.location_id > 0 `
        if(req.plant && req.plant != 5){
            getEntities = getEntities + ` and lo.plant = ${req.plant}`
        }
        getEntities = getEntities + ` GROUP BY lo.location_name ORDER BY lo.location_name `
        const data: { location_id: number, location_name: string, plant: number }[] = await manager.query(getEntities)
        const response = [];
        data.forEach(e => {
            response.push(new AssetsLocationDto(e.location_id, e.location_name, null, true, null, null, e.plant))
        })
        return new CommonResponse(true, 1, 'Data retrieved', response)

    }

    async getAssetsCountByLocations(req:LocationById) : Promise<CommonResponse> {
        const manager = getManager();
        let getEntities
        getEntities = `SELECT COUNT(aas.asset_id) as assetsCount
        FROM `+appSettings.assets_db+`.assets aas
        LEFT JOIN `+appSettings.assets_db+`.asset_location_mapping lom ON lom.asset_id = aas.asset_id
        LEFT JOIN `+appSettings.assets_db+`.location lo ON lo.location_id = lom.location_id
        WHERE aas.asset_id > 0`
        if(req.locationId) {
            getEntities = getEntities + ` and lo.location_id = ${req.locationId}`
        }
        const data = await manager.query(getEntities)
        return new CommonResponse(true,1,'Data Retrieved',data)
    }

}